import { defineNuxtPlugin } from '#app/nuxt'
import { LazyContentBlockAccordion, LazyContentBlockAccordionItem, LazyContentBlockAdditionalSlot, LazyContentBlockAdditionalSlotItem, LazyContentBlockArticlesHero, LazyContentBlockArticlesHeroItem, LazyContentBlockArticlesHeroMainItem, LazyContentBlockArticlesNews, LazyContentBlockArticlesNewsItem, LazyContentBlockContacts, LazyContentBlockContactsItem, LazyContentBlockCountdown, LazyContentBlockCountdownTimer, LazyContentBlockCountdownTimerItem, LazyContentBlockGallery, LazyContentBlockGalleryGrid, LazyContentBlockGalleryGridItem, LazyContentBlockGalleryGridManual, LazyContentBlockGalleryLatest, LazyContentBlockGalleryLatestItem, LazyContentBlockGalleryLatestList, LazyContentBlockGallerySlider, LazyContentBlockGallerySliderBlock, LazyContentBlockGallerySliderBlockItem, LazyContentBlockGallerySliderManual, LazyContentBlockGameNews, LazyContentBlockGamePromoBroadcast, LazyContentBlockGamePromo, LazyContentBlockGamePromoLink, LazyContentBlockGamePromoTeam, LazyContentBlockGoogleAd, LazyContentBlockHeroArticles, LazyContentBlockHeroVideo, LazyContentBlockHeroWithButtonsButton, LazyContentBlockHeroWithButtons, LazyContentBlockLatestNews, LazyContentBlockLatestVideoArticles, LazyContentBlockLeagueGamePromo, LazyContentBlockLeapFormEmbed, LazyContentBlockLinks, LazyContentBlockLinksItem, LazyContentBlockNcfContactform, LazyContentBlockNews, LazyContentBlockNewsItem, LazyContentBlockPromoItems, LazyContentBlockPromoItemsItem, LazyContentBlockScheduleEvents, LazyContentBlockScheduleEventsItem, LazyContentBlockScheduleEventsSwiper, LazyContentBlockScheduleEventsTeam, LazyContentBlockScheduleSlider, LazyContentBlockShop, LazyContentBlockShopItem, LazyContentBlockSinglePromo, LazyContentBlockSponsors, LazyContentBlockSponsorsItem, LazyContentBlockTeamGamePromo, LazyContentBlockTicketCentral, LazyContentBlockTicketCentralItem, LazyContentBlockTickets, LazyContentBlockTicketsItem, LazyContentBlockVideo, LazyContentBlockVideoHeroButton, LazyContentBlockVideoHero, LazyContentBlockVideoArticles, LazyContentBlockVideoArticlesItem, LazyMenuColumnMenuItem, LazyMenuIconMenuItem, LazyMenu, LazyMenuItem, LazyMenuList, LazyMenuStaticUrlMenuItem, LazyMenuTextMenuItem, LazyFacebookVideoEmbed, LazyStreamVideoEmbed, LazyWmtVideoEmbed, LazyYoutubeVideoEmbed, LazyContentBlocks, LazyContentBlocksItem, LazyContentBlockImage, LazyContentBlockParagraph, LazyContentBlockPromoBanner, LazyContentBlockQuote, LazySectionWrapper, LazyUIButton, LazyUIDynamicHeading, LazyUIEmbedHtml, LazyUIIcon, LazyUIImage, LazyUILoadingCard, LazyUISelect, LazyUITableCell, LazyUITableHead, LazyUITable, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["ContentBlockAccordion", LazyContentBlockAccordion],
["ContentBlockAccordionItem", LazyContentBlockAccordionItem],
["ContentBlockAdditionalSlot", LazyContentBlockAdditionalSlot],
["ContentBlockAdditionalSlotItem", LazyContentBlockAdditionalSlotItem],
["ContentBlockArticlesHero", LazyContentBlockArticlesHero],
["ContentBlockArticlesHeroItem", LazyContentBlockArticlesHeroItem],
["ContentBlockArticlesHeroMainItem", LazyContentBlockArticlesHeroMainItem],
["ContentBlockArticlesNews", LazyContentBlockArticlesNews],
["ContentBlockArticlesNewsItem", LazyContentBlockArticlesNewsItem],
["ContentBlockContacts", LazyContentBlockContacts],
["ContentBlockContactsItem", LazyContentBlockContactsItem],
["ContentBlockCountdown", LazyContentBlockCountdown],
["ContentBlockCountdownTimer", LazyContentBlockCountdownTimer],
["ContentBlockCountdownTimerItem", LazyContentBlockCountdownTimerItem],
["ContentBlockGallery", LazyContentBlockGallery],
["ContentBlockGalleryGrid", LazyContentBlockGalleryGrid],
["ContentBlockGalleryGridItem", LazyContentBlockGalleryGridItem],
["ContentBlockGalleryGridManual", LazyContentBlockGalleryGridManual],
["ContentBlockGalleryLatest", LazyContentBlockGalleryLatest],
["ContentBlockGalleryLatestItem", LazyContentBlockGalleryLatestItem],
["ContentBlockGalleryLatestList", LazyContentBlockGalleryLatestList],
["ContentBlockGallerySlider", LazyContentBlockGallerySlider],
["ContentBlockGallerySliderBlock", LazyContentBlockGallerySliderBlock],
["ContentBlockGallerySliderBlockItem", LazyContentBlockGallerySliderBlockItem],
["ContentBlockGallerySliderManual", LazyContentBlockGallerySliderManual],
["ContentBlockGameNews", LazyContentBlockGameNews],
["ContentBlockGamePromoBroadcast", LazyContentBlockGamePromoBroadcast],
["ContentBlockGamePromo", LazyContentBlockGamePromo],
["ContentBlockGamePromoLink", LazyContentBlockGamePromoLink],
["ContentBlockGamePromoTeam", LazyContentBlockGamePromoTeam],
["ContentBlockGoogleAd", LazyContentBlockGoogleAd],
["ContentBlockHeroArticles", LazyContentBlockHeroArticles],
["ContentBlockHeroVideo", LazyContentBlockHeroVideo],
["ContentBlockHeroWithButtonsButton", LazyContentBlockHeroWithButtonsButton],
["ContentBlockHeroWithButtons", LazyContentBlockHeroWithButtons],
["ContentBlockLatestNews", LazyContentBlockLatestNews],
["ContentBlockLatestVideoArticles", LazyContentBlockLatestVideoArticles],
["ContentBlockLeagueGamePromo", LazyContentBlockLeagueGamePromo],
["ContentBlockLeapFormEmbed", LazyContentBlockLeapFormEmbed],
["ContentBlockLinks", LazyContentBlockLinks],
["ContentBlockLinksItem", LazyContentBlockLinksItem],
["ContentBlockNcfContactform", LazyContentBlockNcfContactform],
["ContentBlockNews", LazyContentBlockNews],
["ContentBlockNewsItem", LazyContentBlockNewsItem],
["ContentBlockPromoItems", LazyContentBlockPromoItems],
["ContentBlockPromoItemsItem", LazyContentBlockPromoItemsItem],
["ContentBlockScheduleEvents", LazyContentBlockScheduleEvents],
["ContentBlockScheduleEventsItem", LazyContentBlockScheduleEventsItem],
["ContentBlockScheduleEventsSwiper", LazyContentBlockScheduleEventsSwiper],
["ContentBlockScheduleEventsTeam", LazyContentBlockScheduleEventsTeam],
["ContentBlockScheduleSlider", LazyContentBlockScheduleSlider],
["ContentBlockShop", LazyContentBlockShop],
["ContentBlockShopItem", LazyContentBlockShopItem],
["ContentBlockSinglePromo", LazyContentBlockSinglePromo],
["ContentBlockSponsors", LazyContentBlockSponsors],
["ContentBlockSponsorsItem", LazyContentBlockSponsorsItem],
["ContentBlockTeamGamePromo", LazyContentBlockTeamGamePromo],
["ContentBlockTicketCentral", LazyContentBlockTicketCentral],
["ContentBlockTicketCentralItem", LazyContentBlockTicketCentralItem],
["ContentBlockTickets", LazyContentBlockTickets],
["ContentBlockTicketsItem", LazyContentBlockTicketsItem],
["ContentBlockVideo", LazyContentBlockVideo],
["ContentBlockVideoHeroButton", LazyContentBlockVideoHeroButton],
["ContentBlockVideoHero", LazyContentBlockVideoHero],
["ContentBlockVideoArticles", LazyContentBlockVideoArticles],
["ContentBlockVideoArticlesItem", LazyContentBlockVideoArticlesItem],
["MenuColumnMenuItem", LazyMenuColumnMenuItem],
["MenuIconMenuItem", LazyMenuIconMenuItem],
["Menu", LazyMenu],
["MenuItem", LazyMenuItem],
["MenuList", LazyMenuList],
["MenuStaticUrlMenuItem", LazyMenuStaticUrlMenuItem],
["MenuTextMenuItem", LazyMenuTextMenuItem],
["FacebookVideoEmbed", LazyFacebookVideoEmbed],
["StreamVideoEmbed", LazyStreamVideoEmbed],
["WmtVideoEmbed", LazyWmtVideoEmbed],
["YoutubeVideoEmbed", LazyYoutubeVideoEmbed],
["ContentBlocks", LazyContentBlocks],
["ContentBlocksItem", LazyContentBlocksItem],
["ContentBlockImage", LazyContentBlockImage],
["ContentBlockParagraph", LazyContentBlockParagraph],
["ContentBlockPromoBanner", LazyContentBlockPromoBanner],
["ContentBlockQuote", LazyContentBlockQuote],
["SectionWrapper", LazySectionWrapper],
["UIButton", LazyUIButton],
["UIDynamicHeading", LazyUIDynamicHeading],
["UIEmbedHtml", LazyUIEmbedHtml],
["UIIcon", LazyUIIcon],
["UIImage", LazyUIImage],
["UILoadingCard", LazyUILoadingCard],
["UISelect", LazyUISelect],
["UITableCell", LazyUITableCell],
["UITableHead", LazyUITableHead],
["UITable", LazyUITable],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
